import { gql } from "@apollo/client";

export const ADD_LOG = gql`
  mutation AddLog($userid: Int!, $event_type: String!, $timestamp: String!, $additional_data: String) {
    addLog(userid: $userid, event_type: $event_type, timestamp: $timestamp, additional_data: $additional_data) {
			status
			response
			error
    }
  }
`;
